// Runtime feature flags. Keep this file flat and dependency-free so it
// can be imported from anywhere (views, services, theme provider) without
// pulling in the store.

const features = {
  darkTheme: false,
  marketIntelligence: false
};
export function isEnabled(name) {
  return Boolean(features[name]);
}
export default features;